import { jsx as a, Fragment as b, jsxs as i } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import v from "./logo.webp.js";
import O from "./menu-dropdown-wrapper-mobile.svg.js";
import y from "./burger.svg.js";
import A from "./close.svg.js";
import { useState as C, useCallback as d, useMemo as G } from "react";
import { AccountLink as x } from "./account-link/index.js";
import I from "./chevron-right.svg.js";
import { DropdownMenuItemMobile as S } from "./dropdown-menu-item/index.js";
import { useDisableScroll as H } from "../../../utils/use-disable-scroll.js";
import { areasOfLawData as D } from "../../../constants.js";
import { convertToKebabCase as R } from "../../../utils/case-conversion.js";
import { MobileAccountModalLink as T } from "./mobile-account-modal/index.js";
import { ForLawyersMenuButtonMobile as q } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemMobile as $ } from "./get-help-menu-item/index.js";
import { GradientButton as B } from "./gradient-button/index.js";
import { MenuChatButtonMobile as j } from "./chat-button/index.js";
import E from "./chevron-right-gradient.svg.js";
const re = (t) => {
  const {
    isAuthenticated: u,
    openAuthModal: n,
    getTranslation: s,
    language: M,
    lmpEnabled: o,
    onRequestLawyer: h,
    hideLinks: g
  } = t, [p, l] = C(!1);
  H({ isDisabled: p });
  const r = d(() => {
    l(!0);
  }, []), m = d(() => {
    l(!1);
  }, []), f = d(() => {
    l(!1), u || n();
  }, [u, n]), c = d(() => {
    l(!1), t.logout();
  }, [t.logout]);
  return /* @__PURE__ */ a(b, { children: /* @__PURE__ */ i(
    "div",
    {
      className: `${e.menuModalOverlay} ${p ? e.menuModalOverlayOpen : ""}`,
      children: [
        /* @__PURE__ */ a(
          F,
          {
            isMenuOpen: p,
            closeMenu: m,
            openMenu: r,
            onAccountClick: f,
            handleLogout: c,
            isAuthenticated: t.isAuthenticated,
            userImage: t.userImage,
            hasNotifications: t.hasNotifications,
            language: M,
            getTranslation: s,
            isLawyerSupported: t.isLawyerSupported,
            onRequestLawyer: h,
            hideLinks: g
          }
        ),
        !g && /* @__PURE__ */ i(b, { children: [
          /* @__PURE__ */ a(
            W,
            {
              isAuthenticated: t.isAuthenticated,
              language: M,
              handleLogout: c,
              closeMenu: m,
              hasNotifications: t.hasNotifications,
              userImage: t.userImage,
              onAccountClick: f,
              getTranslation: s,
              isLawyerSupported: t.isLawyerSupported,
              onRequestLawyer: h,
              lmpEnabled: o
            }
          ),
          /* @__PURE__ */ a(O, { className: e.mobileBGIcon })
        ] })
      ]
    }
  ) });
}, F = (t) => {
  const {
    isMenuOpen: u,
    closeMenu: n,
    openMenu: s,
    onAccountClick: M,
    handleLogout: o,
    isAuthenticated: h,
    hasNotifications: g,
    userImage: p,
    language: l,
    getTranslation: r,
    isLawyerSupported: m,
    onRequestLawyer: f,
    hideLinks: c
  } = t, [k, L] = C(!1), N = d(() => {
    L(!0);
  }, []), w = d(() => {
    L(!1);
  }, []);
  return /* @__PURE__ */ i("div", { className: e.mobileMenuContainer, children: [
    !c && /* @__PURE__ */ a(
      "div",
      {
        className: e.menuIconContainer,
        onClick: u ? n : s,
        children: /* @__PURE__ */ i("div", { className: e.iconWrapper, children: [
          /* @__PURE__ */ a(
            "img",
            {
              src: y,
              alt: "hamburger",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.defaultIcon} ${u ? e.hidden : ""}`
            }
          ),
          /* @__PURE__ */ a(
            "img",
            {
              src: A,
              alt: "close",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.activeIcon} ${u ? "" : e.hidden}`
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ a(
      "a",
      {
        href: l ? `/${l}` : "/",
        className: e.logoContainer,
        children: /* @__PURE__ */ a(
          "img",
          {
            src: v,
            alt: "logo",
            width: 130,
            height: 18,
            className: e.logo
          }
        )
      }
    ),
    !c && (h ? /* @__PURE__ */ a(
      x,
      {
        isAuthenticated: h,
        userImage: p,
        openAuthModal: M,
        logout: o,
        hasNotifications: g,
        closeMenuModal: n,
        language: l,
        getTranslation: r
      }
    ) : m ? /* @__PURE__ */ i(b, { children: [
      /* @__PURE__ */ a(
        B,
        {
          label: r("pages.get-help"),
          onClick: N,
          className: e.mobileMenuGradientButton
        }
      ),
      /* @__PURE__ */ a(
        $,
        {
          language: l || "en",
          titleLabel: r("pages.get-help"),
          getTranslation: r,
          isLawyerSupported: m,
          onRequestLawyer: f,
          closeMenu: w,
          externalIsOpen: k,
          externalOnOpen: N,
          externalOnClose: w,
          hideDefaultTrigger: !0
        }
      )
    ] }) : /* @__PURE__ */ a(j, { getTranslation: r }))
  ] });
}, W = (t) => {
  const {
    handleLogout: u,
    language: n,
    closeMenu: s,
    onAccountClick: M,
    getTranslation: o,
    isLawyerSupported: h,
    lmpEnabled: g,
    onRequestLawyer: p
  } = t, [l, r] = C(!1), m = d(() => {
    r(!0);
  }, []), f = d(() => {
    r(!1);
  }, []), c = G(() => {
    var L;
    const k = (L = D[n]) == null ? void 0 : L.map((N) => ({
      ...N,
      path: `/${n}/topics/${R(N.title)}`
    }));
    return k || null;
  }, [n]);
  return /* @__PURE__ */ i("div", { className: e.menuModalContent, children: [
    /* @__PURE__ */ i("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      /* @__PURE__ */ i(
        "div",
        {
          className: `${e.mainMenuLink} ${e.gradientText}`,
          onClick: m,
          children: [
            /* @__PURE__ */ a("div", { className: e.gradientTextContent, children: o("pages.get-help") }),
            /* @__PURE__ */ a(E, { className: `${e.arrowIcon}` })
          ]
        }
      ),
      /* @__PURE__ */ a(
        $,
        {
          language: n,
          titleLabel: o("pages.get-help"),
          getTranslation: o,
          isLawyerSupported: h,
          onRequestLawyer: p,
          closeMenu: f,
          externalIsOpen: l,
          externalOnOpen: m,
          externalOnClose: f,
          hideDefaultTrigger: !0
        }
      )
    ] }),
    /* @__PURE__ */ i("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      g ? /* @__PURE__ */ i("a", { href: n ? `/${n}/find` : "/find", className: e.mainMenuLink, onClick: s, children: [
        "Browse lawyers",
        /* @__PURE__ */ a(I, { className: e.arrowIcon })
      ] }) : null,
      c && /* @__PURE__ */ a(
        S,
        {
          language: n,
          titleLabel: o("pages.legal-topics"),
          link: `/${n}/topics`,
          items: c,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      g ? null : /* @__PURE__ */ a(
        "a",
        {
          href: `/${n}/about/company`,
          className: e.mainMenuLink,
          onClick: s,
          children: o("pages.about")
        }
      ),
      /* @__PURE__ */ a(
        q,
        {
          language: n,
          getTranslation: o,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      t.isAuthenticated ? /* @__PURE__ */ a(
        T,
        {
          language: n,
          handleLogout: u,
          userImage: t.userImage,
          hasNotifications: t.hasNotifications,
          getTranslation: o
        }
      ) : /* @__PURE__ */ i("div", { className: e.mainMenuLink, onClick: M, children: [
        o("pages.account"),
        /* @__PURE__ */ a(I, { className: e.arrowIcon })
      ] })
    ] }),
    /* @__PURE__ */ i("div", { className: e.menuLinksContainer, children: [
      n.includes("en") && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/insights` : "/insights",
          className: e.subMenuLink,
          onClick: s,
          children: o("pages.insights")
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/faqs` : "/faqs",
          className: e.subMenuLink,
          onClick: s,
          children: o("pages.faqs")
        }
      ),
      c && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/directory` : "/directory",
          className: e.subMenuLink,
          onClick: s,
          children: "Case study directory"
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/contact-us` : "/contact-us",
          className: e.subMenuLink,
          onClick: s,
          children: o("pages.contact-us")
        }
      )
    ] })
  ] });
};
export {
  re as MobileMenu
};
